import { calculatePiecesFromWeight, calculateWeightFromPieces } from "../shared/amount-chooser-panel/index";
export function normalizeInputQuantity(
	input: number,
	maxQuantityNormal: number,
	maxQuantityWeight: number,
	isWeighted: boolean,
	weightPerPiece: number | null | undefined,
): number {
	const maxQuantity = isWeighted ? maxQuantityWeight : maxQuantityNormal;
	const quantity =
		isWeighted && typeof weightPerPiece === "number" && weightPerPiece !== 0
			? calculateWeightFromPieces(input, weightPerPiece)
			: input;
	return floor3dec(Math.min(Math.max(quantity, 0), maxQuantity), isWeighted);
}
export function convertStateQuantity(
	quantity: number,
	isWeighted: boolean,
	weightPerPiece: number | null | undefined,
): number {
	return isWeighted === true && typeof weightPerPiece === "number" && weightPerPiece !== 0
		? calculatePiecesFromWeight(quantity, weightPerPiece)
		: floor3dec(quantity, isWeighted);
}

function floor3dec(quantity: number, isWeighted: boolean): number {
	return isWeighted ? Math.floor(quantity * 1000) / 1000 : Math.floor(quantity);
}
